import type { BuilderState, StepId } from './types';

type Listener = () => void;

/**
 * Simple observable state store for the builder.
 * Components subscribe to state changes and re-render when notified.
 */
export class BuilderStore {
  private state: BuilderState;
  private listeners: Set<Listener> = new Set();

  constructor(initial: BuilderState) {
    this.state = { ...initial };
  }

  /** Get current state (read-only snapshot) */
  getState(): Readonly<BuilderState> {
    return this.state;
  }

  /** Update state and notify all listeners */
  setState(partial: Partial<BuilderState>): void {
    this.state = { ...this.state, ...partial };
    this.notify();
  }

  /** Subscribe to state changes. Returns an unsubscribe function. */
  subscribe(listener: Listener): () => void {
    this.listeners.add(listener);
    return () => this.listeners.delete(listener);
  }

  /** Navigate to a step */
  goToStep(step: StepId): void {
    this.setState({ currentStep: step });
  }

  private notify(): void {
    for (const listener of this.listeners) {
      listener();
    }
  }
}

export function createStore(initial: BuilderState): BuilderStore {
  return new BuilderStore(initial);
}
